const getVal = (time1) => {
  if (!time1) {
    return 0;
  }
  let t1 = time1.split(':');
  return parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60 + parseInt(t1[2]);
};

/**
 * validate tariff form
 * @param {*} values
 * @returns
 */
export const validate = (values) => {
  // console.log("🚀 ~ validate ~ values:", values)
  const errors = {};
  let zone;
  if (!values?.zones) {
    return errors;
  }

  const addError = (zone_id, field, error, interval_id, interval_fn) => {
    if (!errors.zones) {
      errors.zones = {};
    }

    if (!errors.zones[zone_id]) {
      errors.zones[zone_id] = {};
    }

    if (interval_id) {
      if (!errors.zones[zone_id][field]) {
        errors.zones[zone_id][field] = {};
      }
      if (!errors.zones[zone_id][field][interval_id]) {
        errors.zones[zone_id][field][interval_id] = {};
      }
      
      errors.zones[zone_id][field][interval_id][interval_fn] = error;
      return;
    }

    errors.zones[zone_id][field] = error;
  };

  Object.keys(values?.zones).forEach((zone_id) => {
    zone = values?.zones[zone_id];

    // check for difference between day and night time
    if (zone.start_day_time !== undefined) {
      const start = zone.start_day_time;
      const end = zone.end_day_time;
      if (start && end) {
        let s1 = getVal(start);
        let e1 = getVal(end);
        if (e1 - s1 < 3600) {
          addError(zone_id, 'end_day_time', 'Разница между дневным и ночным временем не может быть меньше часа');
        }
      }
    }

    // check for same intervals
    if (zone.intervals !== undefined) {
      // console.log('zone.intervals', zone.intervals);
      const old = {};
      zone.intervals.forEach((el, idx) => {
        if (old[el.start_at] !== undefined) {
          addError(zone_id, 'intervals', 'Время уже задано', idx, 'start_at');
          // addError(zone_id, 'intervals', 'Время уже задано', idx, 'amount');
        }
        old[el.start_at] = 1;
      });
    }

    // check for CAPS2-1881
    // day_hour_cost >= day_amount_limit

    // check for tarifficator
    if (zone.day_hour_cost !== undefined) {
      const v1 = zone.day_hour_cost;
      const v2 = zone.day_amount_limit;
      if (v2 > 0 && v2 < v1) {
        addError(zone_id, 'day_amount_limit', 'Максимальная стоимость за период не может быть ниже значения Стоимости часа');
      }
    }
    if (zone.night_hour_cost !== undefined) {
      const v1 = zone.night_hour_cost;
      const v2 = zone.night_amount_limit;
      if (v2 > 0 && v2 < v1) {
        addError(zone_id, 'night_amount_limit', 'Максимальная стоимость за период не может быть ниже значения Стоимости часа');
      }
    }
  });

  // if (errors !== undefined) {
  //   errors.whateverKey = Date.now();
  // }
  // console.log('🚀 ~ validate ~ errors:', errors);

  return errors;
};
